import React, { useRef } from 'react';
import { useClerk } from '@clerk/clerk-react';
import DecryptedText from '../components/DecryptedText';
import PrismBackground from '../components/PrismBackground';
import PublicEventsBounties from '../components/PublicEventsBounties';
import heroRevealImg from '../assets/org_logos-p-800.png';
import hackteamImg from '../assets/hackteam.png';

const Home: React.FC = () => {
  const { openSignUp, openSignIn } = useClerk();
  const heroRevealImgRef = useRef<HTMLImageElement>(null);

  return (
    <div className="min-h-screen" style={{ background: 'transparent' }}>
      <PrismBackground />
      {/* Hero Section */}
      <section
        className="relative overflow-hidden"
        style={{ background: 'transparent' }}
        onMouseMove={(e) => {
          const rect = e.currentTarget.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;
          const el = heroRevealImgRef.current;
          if (el) {
            el.style.setProperty('--mx', `${x}px`);
            el.style.setProperty('--my', `${y}px`);
          }
        }}
        onMouseLeave={() => {
          const el = heroRevealImgRef.current;
          if (el) {
            el.style.setProperty('--mx', '-9999px');
            el.style.setProperty('--my', '-9999px');
          }
        }}
      >
        <div className="absolute inset-0">
          <div className="absolute top-0 left-0 w-72 h-72 bg-transparent rounded-full blur-3xl animate-float"></div>
          <div className="absolute top-20 right-0 w-96 h-96 bg-transparent rounded-full blur-3xl animate-float" style={{ animationDelay: '1s' }}></div>
          <div className="absolute bottom-0 left-1/3 w-80 h-80 bg-transparent rounded-full blur-3xl animate-float" style={{ animationDelay: '2s' }}></div>
        </div>

        <img
          ref={heroRevealImgRef}
          src={heroRevealImg}
          alt="Hero reveal effect"
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: '0',
            left: '0',
            zIndex: 5,
            objectFit: 'cover',
            mixBlendMode: 'lighten',
            opacity: 0.4,
            pointerEvents: 'none',
            '--mx': '-9999px',
            '--my': '-9999px',
            WebkitMaskImage: 'radial-gradient(circle at var(--mx) var(--my), rgba(255,255,255,1) 0px, rgba(255,255,255,0.95) 80px, rgba(255,255,255,0.6) 160px, rgba(255,255,255,0.25) 240px, rgba(255,255,255,0) 320px)',
            maskImage: 'radial-gradient(circle at var(--mx) var(--my), rgba(255,255,255,1) 0px, rgba(255,255,255,0.95) 80px, rgba(255,255,255,0.6) 160px, rgba(255,255,255,0.25) 240px, rgba(255,255,255,0) 320px)',
            WebkitMaskRepeat: 'no-repeat',
            maskRepeat: 'no-repeat'
          } as React.CSSProperties}
        />

        <div className="relative z-10 max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center md:items-start mt-40 mb-20 gap-6">
            <div className="w-full md:w-1/2 text-center md:text-left animate-fadeIn">
              <h1 className="text-6xl md:text-7xl lg:text-8xl font-black font-space mb-6" style={{ marginTop: '50px', color: '#500295' }}>
                <DecryptedText
                  text="AI Builders Hackathons Platform"
                  animateOn="view"
                  revealDirection="start"
                  speed={100}
                  sequential={true}
                  className="style={{ color: '#500295' }}"
                />
              </h1>

              <p className="text-xl lg:text-2xl text-gray-600 font-inter mb-6 max-w-3xl mx-auto md:mx-0 leading-relaxed">
                Go Solo, Look for a Team or Look for Members.
              </p>
            </div>

            {/* Right-side image area visible on desktop: team image only */}
            <div className="hidden md:flex md:w-1/2 flex-col justify-start items-center">
              <img src={hackteamImg} alt="Hack Team" className="max-w-sm lg:max-w-md object-contain" />
            </div>
          </div>
        </div>
      </section>
      {/* Public Events and Bounties */}
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <PublicEventsBounties />
      </div>
    </div>
  );
};

export default Home;
